import styled from '@emotion/styled';

import { PaperLayout as PaperLayoutBase } from 'shared/components/layouts';

// Container

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

// Content

export const Content = styled(PaperLayoutBase)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
`;
